import { useAuth } from "react-oidc-context";
import { Box, Button, Paper, Typography, Alert, Stack } from "@mui/material";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import { BrandMark } from "../components/BrandMark";
import { brand } from "../theme";

export function Login() {
  const auth = useAuth();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        p: 2,
        // Os dois orbes que ficavam aqui eram feitos de rgba(64,120,153)
        // e rgba(121,30,148) — as cores de `logo-blue.svg` e
        // `logo-purple.svg`, que sao variantes alternativas do logo e
        // nao cor de interface. Sobra o fundo que o resto da plataforma
        // usa, com a marca dando o contraste.
        background: brand.gradientDark,
      }}
    >
      <Paper
        elevation={24}
        sx={{
          width: "100%",
          maxWidth: 440,
          p: { xs: 4, sm: 5 },
          borderRadius: 4,
          bgcolor: "background.paper",
          textAlign: "center",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <BrandMark size={40} layout="horizontal" />
        </Box>

        <Typography variant="h4" sx={{ fontWeight: 600, color: "primary.dark", mb: 0.5 }}>
          Plataforma UpOwl
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
          Entre com sua conta corporativa para continuar.
        </Typography>

        {auth.error && (
          <Alert severity="error" sx={{ mb: 3, textAlign: "left" }}>
            <strong>Erro de autenticação.</strong>
            <br />
            Tente novamente ou fale com o admin do seu tenant.
          </Alert>
        )}

        <Button
          fullWidth
          size="large"
          variant="contained"
          startIcon={<LoginRoundedIcon />}
          onClick={() => void auth.signinRedirect()}
          data-testid="btn-sso"
          sx={{
            py: 1.5,
            fontSize: 15,
            fontWeight: 600,
            background: "linear-gradient(135deg, #2c4055 0%, #576b82 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #021a2c 0%, #2c4055 100%)",
            },
          }}
        >
          Entrar com SSO
        </Button>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={0.75}
          sx={{ mt: 3, color: "text.secondary" }}
        >
          <LockRoundedIcon sx={{ fontSize: 14 }} />
          <Typography variant="caption">
            Protegido por OpenID Connect
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
